import type { RouteObject } from 'react-router-dom'
import { PRINTER_URL } from './printer/Printer.navigator'
import PrinterPage from './printer/Printer.page'
import { tokenGeneratorLoader } from './token-generator/TokenGenerator.loader'
import { TOKEN_GENERATOR_URL } from './token-generator/TokenGenerator.navigator'
import TokenGeneratorPage from './token-generator/TokenGenerator.page'
import { TOKEN_TYPE_URL } from './token-type/TokenType.navigator'
import TokenTypePage from './token-type/TokenType.page'

export const utilsRoutes: RouteObject[] = [
  {
    id: '(Utils) Token Type',
    path: TOKEN_TYPE_URL,
    element: <TokenTypePage />
  },
  {
    id: '(Utils) Token Generator',
    path: TOKEN_GENERATOR_URL,
    element: <TokenGeneratorPage />,
    loader: tokenGeneratorLoader
  },
  {
    id: '(Utils) Printer',
    path: PRINTER_URL,
    element: <PrinterPage />
  }
]
